import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDClickableText, FDHeadlineText, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';
import Relationship from 'facet-rest/src/domain/Relationship';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const NoItemsAdded = ({
  title, subtitle, icon, firstItemRel,
}) => {
  const { loadModalCollectionByLink } = useModalContext();
  return (
    <FDPaper
      appearance={'outlined'}
      width={'100%'}
      padding={4}
      {...dataAttrs('no-items-added-container')}
    >
      <FDStack direction={'column'} spacing={3} alignItems={'center'}>
        <FDIcon size={'xl'} icon={icon} />
        <FDStack direction={'column'} spacing={1} alignItems={'center'}>
          <FDHeadlineText size={'sm'} value={title} color={'textSecondary'} />
          { subtitle ? <FDBodyText value={subtitle} color={'textDisabled'} align={'center'} /> : null }
          {
            firstItemRel
              ? <FDBodyText
                color={'textSecondary'}
                align={'center'}
                value={<FDClickableText
                  appearance={'standalone'}
                  label={firstItemRel.meta('prompt')}
                  onClick={() => { loadModalCollectionByLink(firstItemRel.link('related').url()); }}
                  {...dataAttrs('add-first-item-clickable-text')}
                />}
              />
              : null
          }
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

NoItemsAdded.defaultProps = {
  subtitle: undefined,
  firstItemRel: undefined,
};

NoItemsAdded.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.string.isRequired,
  firstItemRel: PropTypes.instanceOf(Relationship),

};

export { NoItemsAdded };
